import AbstractPeriodReportSection from "./AbstractPeriodReportSection.js";
import Report from "../../../reports/reports/Report.js";

/**
 * Abstract section of a period report having a specific report template for its embedded report.
 * The embedded report can be the system default report or an overridden report.
 * Remark : getReportId() should return the associated Id to be retrieved from the server.
 *
 * @abstract
 * @param {Report} [spec.report] - Interpreted report template.
 */
export default class AbstractReportTemplateSection extends AbstractPeriodReportSection {
	constructor({ report } = {}) {
		super(...arguments);
		this._report = report;
	}

	getReport() {
		return this._report;
	}

	setReport(report) {
		this._report = report;
	}

	canHaveReport() {
		return true;
	}

	_serializedProperties() {
		const data = super._serializedProperties();
		data.report = this._report;

		return data;
	}

	static getReportId() {
		throw new Error("No getReportId() is defined for this class");
	}

	static transformMaterializationData(data, context) {
		data.report &&= Report.materialize(data.report, context);
	}
}
